import Env from '@/config/env'

/**
 * App分享
 * @param {obj} shareObj //分享
 * @item shareTitle 标题
 * @item shareDescribe 描述
 * @item shareOtherImg 分享其他图片（如果不需要默认的图片，就传这参数）
 * @item shareOtherUrl 分享其他url（如果不需要默认的路径，就传这参数）
 */
export const AppShare = shareObj => {
  let { shareTitle, shareDescribe, shareOtherImg, shareOtherUrl } = shareObj
  let isShareImage = false
  let alreadyShareUrl = false //是否已经存在meta标签的name=S=hareUrl
  let objs = document.getElementsByTagName('meta')
  for (let i = 0; i < objs.length; i++) {
    if (objs[i].name === 'shareTitle') {
      objs[i].content = shareTitle
    } else if (objs[i].name === 'shareDescribe') {
      objs[i].content = shareDescribe
    } else if (objs[i].name === 'shareImage' && shareOtherImg) {
      objs[i].content = shareOtherImg
      isShareImage = true
    } else if (objs[i].name === 'shareUrl') {
      alreadyShareUrl = true
      objs[i].content = window.location.origin + shareOtherUrl
    }
  }
  if (shareOtherImg && !isShareImage) {
    let oMeta = document.createElement('meta')
    oMeta.content = shareOtherImg
    oMeta.name = 'shareImage'
    document.getElementsByTagName('head')[0].appendChild(oMeta)
  }
  if (!alreadyShareUrl && shareOtherUrl) {
    let oMeta = document.createElement('meta')
    oMeta.content = window.location.origin + shareOtherUrl
    oMeta.name = 'shareUrl'
    document.getElementsByTagName('head')[0].appendChild(oMeta)
  }
}

/**
 * 复制功能
 * @param {String} copyInfo //要复制的string
 * @param {Function} func //复制成功的回调
 */
export const CopyValue = (copyInfo, func) => {
  return new Promise(resolve => {
    let copyUrl = document.createElement('input') //创建一个input框获取需要复制的文本内容
    copyUrl.value = copyInfo
    let appDiv = document.getElementById('app')
    appDiv.appendChild(copyUrl)
    copyUrl.select()
    document.execCommand('Copy')
    copyUrl.remove()
    if (func) {
      resolve(func())
    }
  })
}

/**
 * 函数防抖 (多少秒内只执行最后一次点击)
 * @param fn
 * @param delay
 * @returns {Function}
 * @constructor
 */
export const Debounce = (fn, t) => {
  let delay = t || 500
  let timer
  // console.log(fn)
  // console.log(typeof fn)
  return function() {
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      fn.apply(this, args)
    }, delay)
  }
}

/**
 * 函数节流 (每多少秒只执行一次)
 * @param fn
 * @param interval
 * @returns {Function}
 * @constructor
 */
export const Throttle = (fn, t) => {
  let last
  let timer
  let interval = t || 500
  return function() {
    let args = arguments
    let now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        last = now
        // fn.apply(this, args)
      }, interval)
    } else {
      last = now
      fn.apply(this, args)
    }
  }
}

/**
 * banner 广告跳转
 * @param that => this 指向
 * @param objectType => 类型
 * @param id => objectUrl
 * @param isshare => 当前banner详情是否可分享
 */
export const AdvertJump = (that, objectType, id, jumpType, isshare) => {
  var path = ''
  switch (objectType) {
    case 1:
      path = `/courseDetail/${id}`
      break
    case 30:
      // 跳转精品课详情
      path = `/courseDetail/detail?courseId=${id}`
      break
    case 36: //h5没有保存图片，防止跳转到app页面
      break
    case 3:
      // 跳转文章
      path = `/article/${id}`
      break
    case 4:
      // 跳转直播列表
      path = `/live?id=${id}`
      break
    case 6:
      // 微课
      path = `/microCourse/detail/${id}`
      break
    case 7:
      var url = id.split(Env.mobileDnsList[0])
      if (url.length === 1) {
        url = id.split(Env.mobileDnsList[1])
      }
      if (url.length > 1) {
        // 跳转活动
        path = url[1]
      } else {
        path = url[0]
      }
      if (isshare === 0) {
        if (path.indexOf('?id') != -1) {
          path = path + '&isBannerShare=' + isshare
        } else {
          path = path + '?isBannerShare=' + isshare
        }
      }
      break
    case 8:
      // 首页
      path = `/`
      break
    case 9:
      // 精品课列表
      path = `/course?id=${id}`
      break
    case 12:
      // 我的
      path = `/my/index`
      break
    case 17:
      path = `/find`
      break
    case 18:
      path = `/vip`
      break
    case 23:
      // 个人主页
      path = `/personal/${id}`
      break
    case 24:
      // 敬请期待弹框
      // that.$router.push({ path: `/personal/${id}` })
      break
    case 25:
      // 学习币明细
      path = `/my/wallet`
      break
    case 27:
      // 我的已购
      path = `/study`
      break
    case 31:
      // 直播详情
      path = `/live/${id}`
      break
    case 33:
      // 特训营详情
      path = `/camp/campDetail?id=${id}`
      break
    case 34:
      // 家慧库VIP专区
      path = `/column/family`
      break
    case 41:
      // 玫瑰园打卡主页
      path = '/rose/index'
      break
    case 44:
      // 广场详情
      path = `/life/preview?id=${id}`
      break
    case 45:
      // 广场首页
      path = '/life/index'
      break
    case 46:
      // 特训营列表
      path = `/camp/index?id=${id}`
      break
    case 48:
      // 问答首页
      path = '/askAnswer'
      break
    case 49:
      // 问答详情页
      path = `/askAnswer/details?id=${id}`
      break
    case 55:
      // 0~18岁专区
      path = `/child/plan`
      break
    case 56:
      // 年报
      path = `/2023annualReport`
      break
    case 70:
      // 推客详情页
      path = `/pushLessons/campDetail?id=${id}`
      break
    default:
      path = '/app'
  }
  // 兼容所有类型否显示分享按钮
  // if (path.indexOf('?id') != -1) {
  //   if (isshare === 0) path = path + '&isBannerShare=' + isshare
  // } else {
  //   if (isshare === 0) path = path + '?isBannerShare=' + isshare
  // }
  let str = /(http|https):\/\/([\w.]+\/?)\S*/
  if (path.match(str)) {
    window.location = path
  } else if (jumpType) {
    that.$router.replace(path)
  } else {
    that.$router.push(path)
  }
}

/**
 * 功能：基于今天获取前几天的日期或者后几天的日期
 * @param {Number} num 前几天或者后几天，eg: 前一天：-1， 后一天：1
 * @param {string} type 年月日分割符号
 * @returns {string} 返回日期：2020-09-09
 */
export const AroundDate = (num, str) => {
  str = str || '-'
  let today = new Date()
  let nowTime = today.getTime()
  let ms = 24 * 3600 * 1000 * num
  today.setTime(parseInt(nowTime + ms))
  let oYear = today.getFullYear()
  let oMoth = (today.getMonth() + 1).toString()
  if (oMoth.length <= 1) oMoth = '0' + oMoth
  let oDay = today.getDate().toString()
  if (oDay.length <= 1) oDay = '0' + oDay
  return oYear + str + oMoth + str + oDay
}

/**
 * 功能：随机一个加密的手机号码
 * @returns {string} eg：170****7457
 */
export const RandomPhone = () => {
  const stars = '****'
  const second = (Math.floor(Math.random() * 7) + 3).toString() //生成3-9数字
  const third = Math.floor(Math.random() * 10).toString() //0-9
  const Suffix = Math.random()
    .toString()
    .substr(2, 4)
  const phone = '1' + second + third + stars + Suffix
  return phone
}

/**
 * 功能：将日期转换为时间戳(兼容IOS和Android)
 * tips：日期没有传入时分秒，默认获取传入日期的0点
 * @param {string} time ,eg：2020-09-11,2020-09-11 11:11:11
 * @returns {string} eg：1599753600000,1599793871000
 */
export const TimeStamp = (time = '') => {
  time = time.replace(new RegExp(/-/gm), '/') //ios 不兼容'-' 会变成NaN
  return new Date(time).getTime()
}

/**
 * 功能：获取code的时候，记录时间戳，并保存在sessionStorage
 */
export const CodeValidTime = () => {
  const time = new Date().getTime()
  sessionStorage.setItem('codeTimeStamp', time)
}

/**
 * 功能：处理两个时间点的间隔是否在一定时间范围内
 * @param {string,number} time1 时间点1 开始时间
 * @param {string,number} time2 时间点2 结束时间
 * @param {string,number} space 间隔时间
 * @returns {Boolean} eg：true/false
 */
export const HandleValidTime = (time1, time2, space) => {
  space = Number(space) || 18 * 60 * 1000
  const result =
    Number(time2) - Number(time1) > 0 && Number(time2) - Number(time1) <= space
  return result
}

/**
 * 功能：去掉url的code=021kBDFa1WLYNz0A9VGa1oL7Tz4kBDFM
 * @param {string} href url
 * @returns {string} url
 */
export const DeleteCode = href => {
  let urlArr = href.split('?')
  if (urlArr.length > 1) {
    let urlArr2 = urlArr[1].split('&')
    let parameters = '?'
    for (const item of urlArr2) {
      if (item.indexOf('code') == -1) {
        parameters += item + '&'
      }
    }
    return urlArr[0] + parameters
  } else {
    return urlArr[0]
  }
}

/**
 * 功能：判断vip是否90天后到期
 * @param {String} time vip到期时间 eg：2020-09-11,2020-09-11 11:11:11
 * @param {String,Number} space 间隔时间
 * @returns {Boolean} true: 小于90天，false：大于90天
 */
export const VipSoonExpire = (time, space) => {
  time = time.replace(new RegExp(/-/gm), '/') //ios 不兼容'-' 会变成NaN
  const vipTimeStamp = new Date(time).getTime() //vip到期时间戳
  const nowDateTimeStamp = new Date().getTime() //当天0点时间戳
  space = Number(space) || 90 * 24 * 60 * 60 * 1000
  const result =
    Number(vipTimeStamp) - Number(nowDateTimeStamp) > 0 &&
    Number(vipTimeStamp) - Number(nowDateTimeStamp) <= space
  return result
}

/**
 * 功能：判断当前时间戳是不是在双十二活动范围内
 * @returns {Boolean} eg：true: 在活动期间，false：不在活动期间
 */
export const IsDoubleTwelve = () => {
  const nowTimeStamp = new Date().getTime()
  const activityStartTimeStamp = TimeStamp('2020-12-12')
  const activityEndTimeStamp = TimeStamp('2021-01-12 23:59:59')
  const result =
    activityStartTimeStamp < nowTimeStamp && nowTimeStamp < activityEndTimeStamp
  return result
}
